jQuery(document).ready(function () {
    jQuery.fn.extend({
        toggleText: function(a, b){
            return this.text(this.text() == b ? a : b);
        }
    });
    jQuery('.js-toggle-desc').on('click', function( event ) {
        event.preventDefault();
        let showText = jQuery(this).data('text-show') ? jQuery(this).data('text-show') : 'Description';
        let hideText = jQuery(this).data('text-hide') ? jQuery(this).data('text-hide') : 'Hide description';

        // Toggle text
        jQuery(this).find('.agend-session__toggle-text').toggleText( hideText, showText );

        // Toggle chevron icon
        let icon$ = jQuery(this).find('.svg-inline--fa');
        if ( icon$.hasClass('fa-chevron-down')) {
            icon$.removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else {
            icon$.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }

        // Toggle description
        jQuery(this)
            .closest('.agend-session')
            .find('.agend-session__description')
            .slideToggle()
    });
});
